import { render } from "./FormulairesStep3.vue?vue&type=template&id=1dc63b67&scoped=true"
import script from "./FormulairesStep3.vue?vue&type=script&lang=js"
export * from "./FormulairesStep3.vue?vue&type=script&lang=js"

import "./FormulairesStep3.vue?vue&type=style&index=0&id=1dc63b67&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc63b67"]])

export default __exports__